import styled from 'styled-components'
import { pxToRem } from '../../utils/style'
import { n20 } from '../../utils/numbers'

export const ClusterDescriptionLabelScrollContainer = styled.div`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	position: relative;

	/* Screens <= 1439px - drag scroll enabled */
	@media (max-width: 1439px) {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
		cursor: grab;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	/* Screens >= 1440px - only tooltip, no drag */
	@media (min-width: 1440px) {
		overflow-x: hidden;
		cursor: default;
	}
`

export const ClusterDescriptionLabelText = styled.span.withConfig({
	shouldForwardProp: prop => prop !== 'variant',
})<{ variant?: 'light' | 'dark' }>`
	font-size: ${pxToRem(n20)};
	font-weight: 700;

	/* Color based on variant */
	color: ${props =>
		props.variant === 'dark'
			? props.theme.palette.color.black.main
			: props.theme.palette.color.white.main};

	/* Styles for ellipsis */
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	user-select: none;

	/* Screens <= 1439px allow scrolling */
	@media (max-width: 1439px) {
		min-width: max-content;
	}
`
